import React from 'react';
import '../assets/css/about.css'
import AboutSwiper from '../components/about-swiper'
import AboutPart1 from '../components/about/aboutPart1'
import AboutPart2 from '../components/about/aboutPart2'
import AboutPart3 from '../components/about/aboutPart3'
import AboutPart4 from '../components/about/aboutPart4'
import HomePart4 from '../components/home/homePart4'
import AboutPart5 from '../components/about/aboutPart5'
import AboutPart6 from '../components/about/aboutPart6'
import ContactPart from '../components/contact/contactPart1'
import Bottom from '../components/bottom'
import { AboutCustomDataProvider } from './context/aboutCustomDataProvider';

const Contact: React.FC = () => {
    return (
        <AboutCustomDataProvider>
            <div className='aboutUs'>
                    <ContactPart />
                    <div style={{height:'80px'}}></div>
            <HomePart4 />

            </div>
            <Bottom />
        </AboutCustomDataProvider>
    )
};

export default Contact;   